import { CSSObject } from '@chakra-ui/react';

export const DepositLimitGrid: CSSObject = {
  py: '4',
};
